
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.6"}},[_c('rect',{attrs:{"x":"4.38","y":"11.25","width":"5","height":"14.38","rx":"1.27","ry":"1.27"}}),_c('rect',{attrs:{"x":"12.5","y":"4.38","width":"5","height":"21.25","rx":"1.27","ry":"1.27"}}),_c('rect',{attrs:{"x":"20.63","y":"16.88","width":"5","height":"8.75","rx":"1.27","ry":"1.27"}})])])
          )
        }
      }
    